module.exports = __webpack_public_path__ + "img/subtitle2.21c5ec7a.png";